import { TCommonData, TWidget } from '@libs/types';
import React from 'react';
import { useInputMask, useSimpleInput } from '../../hooks/useInputs';
import { InputWrapper } from '../UI/Wrapper/InputWrapper';
import styled from './cardInput.module.css';
import { EName } from './types';
import { calcExpDateRegex } from './utils';

type TCardInputExpDate = {
    dataTest?: string;
    label?: string;
    value: string;
    errorMessage?: string;
    isError: boolean;
    initialFocus: boolean;
    tabIndex?: number;
    handleChange: React.ChangeEventHandler;
};
const CardInputExpDate = React.memo(({ dataTest, label, value, tabIndex, errorMessage, isError, handleChange, initialFocus }: TCardInputExpDate) => {
    const { isFocused, isFilled, handleBlur, handleFocus } = useSimpleInput(value);
    const ref = useInputMask(calcExpDateRegex(), '__/__', '', false, initialFocus);

    return (
        <div className={styled.cardExpiredDate}>
            <InputWrapper
                dataTest={dataTest}
                widget={{} as TWidget<TCommonData>}
                labelText={label}
                isFocused={isFocused}
                isFilled={isFilled}
                isError={isError}
                errorMessage={errorMessage}
                isLinedInput
            >
                <input
                    type="tel"
                    ref={ref}
                    autoComplete="off"
                    name={EName.EXP_DATE}
                    value={value}
                    onBlur={handleBlur}
                    onFocus={handleFocus}
                    onChange={handleChange}
                    tabIndex={tabIndex}
                />
            </InputWrapper>
        </div>
    );
});
export { CardInputExpDate };
